import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { enablePush, disablePush, isPushOn, pushErrorText } from "@/lib/push";
import { toast } from "sonner";
import { BellRing, Loader2, Send } from "lucide-react";

export function PushToggle({ accent = "#009C95" }) {
    const [on, setOn] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => { isPushOn().then(setOn).catch(() => setOn(false)); }, []);

    const toggle = async () => {
        setBusy(true);
        try {
            if (on) { await disablePush(); setOn(false); toast("Background notifications turned off on this device"); }
            else { await enablePush(); setOn(true); toast.success("Background notifications are on"); }
        } catch (e) { toast.error(pushErrorText(e)); }
        finally { setBusy(false); }
    };
    const test = async () => {
        try { await api.post("/push/test"); toast.success("Test notification sent"); }
        catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    };

    return (
        <div className="rounded-2xl border border-navy/10 bg-white p-4" data-testid="push-settings">
            <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl" style={{ backgroundColor: `${accent}1a`, color: accent }}><BellRing size={17} /></span>
                <div className="flex-1">
                    <h3 className="font-heading text-sm font-bold text-navy">Background notifications</h3>
                    <p className="text-xs text-navy/50">{on ? "On for this device" : "Get updates even when the app is closed"}</p>
                </div>
                {on === null || busy ? <Loader2 size={18} className="animate-spin text-navy/40" /> : (
                    <button data-testid="push-toggle" onClick={toggle} className={`relative h-6 w-11 rounded-full transition-colors ${on ? "" : "bg-navy/20"}`} style={on ? { backgroundColor: accent } : {}}>
                        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all ${on ? "left-[22px]" : "left-0.5"}`} />
                    </button>
                )}
            </div>
            {on && (
                <button data-testid="push-test-btn" onClick={test} className="mt-3 flex items-center gap-1.5 text-xs font-bold" style={{ color: accent }}><Send size={13} /> Send a test notification</button>
            )}
        </div>
    );
}
